import { TreeItem } from 'lib/types';

const navTree: TreeItem[] = [
	{ id: 'home', label: 'Home', type: 'item', selected: true },
	{ id: 'guides', label: 'Integration Guides', type: 'item' },
	{ id: 'data-sources', label: 'Data Sources', type: 'item' },
	{ id: 'mapping', label: 'Data Mapping', type: 'item' },
	{ id: 'customer-hub', label: 'Single Customer View', type: 'branch', expanded: true,
		nodes: [
			{ id: 'preparation', label: 'Data Preparation', type: 'item'},
			{ id: 'matching', label: 'Matching Rules', type: 'item' },
			{ id: 'reconciliation', label: 'Data Reconciliation Rules', type: 'item' },
			{ id: 'updates', label: 'Customer Update Rules', type: 'item', disabled: true },
		]
	},
	{ id: 'stewardship', label: 'Data Stewardship', type: 'item' },
];

export default navTree;


// WEBPACK FOOTER //
// ./src/data/nav-tree.ts